// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"e8600b40","252":"292888b1","318":"c96acda3","419":"a0db75b2","480":"e43af495","563":"9da218fb","654":"0762f353","774":"0c801b23","883":"2efe01d0"}[chunkId] + ".chunk.js";
};